import type { FaireProductEntity } from "../../entity_types/product";

export const ai_bulk_6: FaireProductEntity = {
  token: "ai_bulk_6",
  type: "product",
  name: "Everybody Night Light",
  brandName: "Ai Bulk Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5fb7f73653555a7d33e34f5bd2cde97ebdfc19969445a639050174245d5aee8d.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 37.25,
  msrpDollars: 74.5,
  description:
    "Everybody stays up late. Everybody has weird dreams. Everybody needs a night light.",
  tags: ["women-owned"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
